import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div className="md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-lg font-bold text-foreground-900">
                  鬼父2解析站
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                专注于鬼父2动画系列的深度内容解析平台，为观众提供专业的剧情分析、人物解读和主题探讨。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                内容分类
              </h4>
              <ul className="flex flex-col gap-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                快速链接
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/category/plot" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    热门解析
                  </Link>
                </li>
                <li>
                  <Link to="/category/sequel" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    最新动态
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                关注我们
              </h4>
              <p className="text-sm text-foreground-600 mb-4">
                持续更新鬼父2相关深度解析内容，欢迎关注获取最新文章推送。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer" aria-label="知乎">
                  <i className="ri-question-answer-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 鬼父2解析站. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">使用条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}